module.exports = __webpack_public_path__ + "img/an23.8da4e569.png";